import { markRaw, ref, type Component, type Raw } from 'vue'

interface ToastData {
  id: symbol
  title?: string
  message?: string
  icon?: Raw<Component>
  duration?: number
  disableSwipe?: boolean
}

const toasts = ref<ToastData[]>([])

export default function useToasts() {
  function postToast(toast: Omit<ToastData, 'id'>) {
    const id = Symbol('toast-id')
    if (toast.icon) {
      toast.icon = markRaw(toast.icon)
    }
    toasts.value = [...toasts.value, { id, ...toast }]
    console.log('Toast posted:', { id, ...toast })
    return id
  }

  function removeToast(id: symbol) {
    toasts.value = toasts.value.filter((toast) => toast.id !== id)
  }

  return {
    toasts,
    postToast,
    removeToast,
  }
}
